import { NodeHelpersType } from '@candulabs/craft';

import { BuiltInComponents } from 'craft/constants';

export const shiftFlowStep = (
  nodeId: string,
  helper: NodeHelpersType,
): [string, string, number] | null => {
  const flowAncestorNodeId = helper(nodeId)
    ?.ancestors(true)
    ?.find((n) => helper(n)?.get()?.data?.name === BuiltInComponents.Flow);

  const flowStepAncestorNodeId = helper(nodeId)
    ?.ancestors(true)
    ?.find((n) => helper(n)?.get()?.data?.name === BuiltInComponents.FlowStep);

  if (!flowAncestorNodeId) {
    return null;
  }
  const flowStepNodeId =
    helper(nodeId).get()?.data.name === BuiltInComponents.FlowStep
      ? nodeId
      : helper(nodeId)
          ?.ancestors(true)
          ?.find((n) => helper(n)?.get()?.data?.name === BuiltInComponents.FlowStep);

  const stateId = helper(flowAncestorNodeId).get()?.data?.props?.stateId;
  const stepId = helper(flowStepNodeId).get().data?.props?.stepId;
  const stepIndex = Math.max(
    helper(flowAncestorNodeId)
      .get()
      ?.data?.nodes.indexOf(flowStepAncestorNodeId || nodeId),
    0,
  );
  return [stateId, stepId, stepIndex];
};

export const shiftFormStep = (
  nodeId: string,
  helper: NodeHelpersType,
): [string, string, number] | null => {
  const formAncestorNodeId = helper(nodeId)
    ?.ancestors(true)
    ?.find((n) => helper(n)?.get()?.data?.name === BuiltInComponents.Form);

  if (!formAncestorNodeId) {
    return null;
  }
  const formStepNodeId =
    helper(nodeId).get()?.data.name === BuiltInComponents.FormStep
      ? nodeId
      : helper(nodeId)
          ?.ancestors(true)
          ?.find((n) => helper(n)?.get()?.data?.name === BuiltInComponents.FormStep);

  const formNode = helper(formAncestorNodeId).get();
  const formId = formNode?.data?.props?.formId;
  const stepId = helper(formStepNodeId).get()?.data?.props?.stepId;

  return [formId, stepId, (formNode?.data.nodes || []).indexOf(formStepNodeId || '')];
};
